export function omissionReasonLabel(reason: string): string {
  return reason.replaceAll("_", " ");
}

export function omissionIsFinding(omission: {
  sourceId: string;
  sourceKind?: string | undefined;
}): boolean {
  return omission.sourceKind === "finding" || omission.sourceId.startsWith("finding_");
}

export function omissionFindingHref(sourceId: string, scanId?: string | null): string {
  const params = new URLSearchParams({ preset: "all", statuses: "" });
  if (scanId) params.set("scanId", scanId);
  return `/findings?${params.toString()}#${encodeURIComponent(sourceId)}`;
}

export function snapshotHeadline(input: {
  nodeCount: number;
  edgeCount: number;
  pathCount: number;
  omittedCount: number;
}): string {
  if (input.pathCount > 0) {
    return "This snapshot has at least one bounded, evidence-backed path. Nothing else is inferred.";
  }
  if (input.edgeCount === 0) {
    return "No validated trust edge is claimed. That is an honest unknown, not a clean attack graph.";
  }
  return "Validated edges exist, but no complete ingress-to-crown-jewel path is admitted on this snapshot.";
}
